import SelectAccountingStatement from './SelectAccountingStatement'

export default SelectAccountingStatement
